import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { ErrorBoundary } from './components/Common/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';
import { ChatProvider } from './context/ChatContext';
import { VoiceProvider } from './context/VoiceContext';
import { registerServiceWorker } from './pwa';
import './index.css';

registerServiceWorker();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Application root is missing');

const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <ChatProvider>
          <VoiceProvider>
            <App />
          </VoiceProvider>
        </ChatProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);